let $ = jQuery;

class AlertBanner {

  constructor($alertBanner) {
    this.$alertBanner = $alertBanner;
    this.$close = this.$alertBanner.find('.alert-close');

    this.bind();
  }

  bind() {
    this.$close.click(() => this.toggleClose());
  }

  toggleClose() {
    this.$alertBanner.css('display', 'none');
  }
}

module.exports = {

  attach: function(context, settings) {
    let $alerts = $('.alert-banner', context);

    if ($alerts.length > 0) {
      $alerts.each((index, el) => {
        let alertBanner = new AlertBanner($(el));
      });
    }
  }
};
